import { Screen } from '~/screens/Root';

export const Root = () => <Screen />;
